$(function () {
    'use strict';

    $('.related-entries--recirc').on('scrollin', lazyLoadImages);

    function lazyLoadImages() {
        var $container = $('.related-entries--recirc');

        $container.off('scrollin', lazyLoadImages);
        $container.find('.related-entries__image').each(function () {
            this.querySelector('img').src = this.getAttribute('data-img-src');
        });
    }
});
